import { render, staticRenderFns } from "./ModifyOrArchiveFacture.vue?vue&type=template&id=e16a6d56&"
import script from "./ModifyOrArchiveFacture.vue?vue&type=script&lang=js&"
export * from "./ModifyOrArchiveFacture.vue?vue&type=script&lang=js&"
import style0 from "./ModifyOrArchiveFacture.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports